import { parse, stringify } from 'devalue'

export const transformer = {
  deserialize: (object: unknown) => parse(object as string),
  serialize: (object: unknown) => stringify(object),
}
